import { Autosuggest } from '@cloudscape-design/components';
import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { getUserType } from '../../pages/commons/functions';
import { useGlobalState } from '../../pages/context/GlobalStateContext';
import { ItemUser } from '../../resources/types';
const _preserve = React.version;

interface SelectUserProps {
    value?: number;
    filter?: string; //"INSTRUCTOR.GLIDER" | "INSTRUCTOR.PLANE" | "INSTRUCTOR.HELI" | "TOW" | "";
    disabled?: boolean;
    readonly?: boolean;
    autoFocus?: boolean;
    placeholder?: string;
    onConfirm?: (selected: ItemUser | undefined) => void;
    //focus?: ()=>void;
}

export type SelectUserHandle = {
    focus: () => void;
};
const SelectUser = forwardRef<SelectUserHandle, SelectUserProps>(
    ({ placeholder = "Buscar usuario", value, filter = "", disabled = false, readonly = false, onConfirm, autoFocus = false }, ref

    ) => {
        const inputRef = useRef<HTMLInputElement>(null);

        useImperativeHandle(ref, () => ({
            focus: () => {
                if (inputRef.current) {
                    inputRef.current.focus();
                    inputRef.current.select();
                }
            }
        }));
        const [keyw, setKeyw] = useState<string>('');
        const { data } = useGlobalState();
        const [users, setUsers] = useState<ItemUser[]>([]);
        const [user, setUser] = useState<ItemUser>();
        const handleUserSelect = ({ detail }: { detail: ItemUser }) => {
            setUser(detail);
            onConfirm(detail);
        };

        useEffect(() => {
            if (data && data.users && data.usersTypes) {
                let mappedUsers = (
                    data.users.map((u: any) => ({
                        idUser: u.idUser,
                        displayName: u.displayName,
                        phone1: u.phone1,
                        email: u.email,
                        RUT: u.RUT,
                        value: u.idUser.toString(),
                        label: u.displayName,
                        labelTag: getUserType(u.idUserType, data).userType || "",
                        description: u.RUT,
                        groupCodes: u.groupCodes || [],
                    }))
                );
                setUsers(mappedUsers);
            }
        }, [data, filter]);
        //}, [data?.users, value, filter]);

        // ✅ Pre-select user if value is given and users are loaded
        useEffect(() => {
            if (value && value > 0 && users.length > 0) {
                const tUser = users.find(u => u.idUser === Number(value));
                if (tUser) {
                    setKeyw(tUser.displayName);
                    setUser(tUser);
                }
            } else if (value == 0) {
                setKeyw("")
            }
        }, [value, users]);
        const filteredUsers = useMemo(() => {
            let list = [...users];

            if (filter) {
                list = list.filter(u =>
                    u.groupCodes.includes(filter)
                );
            }
            if (keyw.trim().length === 0 && list.length < 10) {
                return list;
            }
            if (keyw.trim().length < 2) return [];

            const searchWords = keyw
                .normalize("NFD") // Decomposes accented letters into base letters + diacritic marks
                .replace(/[\u0300-\u036f]/g, "") // Removes the diacritic marks
                .toLowerCase()
                .replace(/[^\w\s]/g, "") // Optional: Removes special characters/punctuation (keeps letters, numbers, and spaces)
                .trim()
                .split(/\s+/)
                .filter(Boolean);

            return list.filter(user => {
                const idUser = user.idUser.toString().toLowerCase();
                const displayName = user.displayName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                const phone = user.phone1.toLowerCase();
                const email = user.email.toLowerCase();
                const RUT = user.RUT.toLowerCase();

                return searchWords.every(word =>
                    idUser.includes(word) ||
                    displayName.includes(word) ||
                    email.includes(word) ||
                    phone.includes(word) ||
                    RUT.includes(word)
                );
            });
        }, [users, filter, keyw]);
        useEffect(() => {
            if (filteredUsers.length === 1 && user?.idUser !== filteredUsers[0].idUser) {
                setUser(filteredUsers[0]);
                onConfirm(filteredUsers[0]);
                setKeyw(filteredUsers[0].displayName);
                if (document.activeElement instanceof HTMLElement) {
                    document.activeElement.blur();
                }
            }
        }, [filteredUsers]);

        return (
            <Autosuggest
                hideEnteredTextOption
                expandToViewport
                autoFocus={autoFocus}
                ref={inputRef}
                readOnly={readonly}
                disabled={disabled}
                onChange={({ detail }) => {
                    setKeyw(detail.value);
                    if (detail.value === "") {
                        setUser(undefined);
                        onConfirm(undefined);
                    }
                }}
                onSelect={({ detail }) => {
                    if (detail.selectedOption) {
                        console.log(detail.selectedOption)
                        handleUserSelect({ detail: detail.selectedOption as ItemUser });
                        setKeyw(detail.selectedOption.label || "");
                    }
                }}
                loadingText={filteredUsers.length === 0 && keyw.trim().length >= 2 ? "No se encontraron usuarios" : undefined}
                statusType={filteredUsers.length === 0 && keyw.trim().length >= 2 ? "loading" : undefined}

                value={keyw}
                options={filteredUsers}
                placeholder={placeholder}
                filteringType="none"
            />
        );
    }
);


export default SelectUser;
